import { AxiosError } from 'axios'
import { axiosInstance as Send } from '../axiosInstance'
import errorHandler from '../../utils/errorHandler'
import { errorType, responseType } from '../type'
import { AccountDetailRes, AccountListRes } from './response'
import config from '../../config'
import constants from '../../constants'

export const getAccountList = async (pageNumber: number, pageSize: number): Promise<responseType<AccountListRes>> => {
  const url = `${constants.prefix}/${constants.versioning}/account/ranking?pageNumber=${pageNumber}&pageSize=${pageSize}`
  return Send.get<responseType<AccountListRes>>(`${config.EXPLORER_BACKEND_URL + url}`).then(
    (response) => response.data,
  )
}

export const GetAccountDetail = async (
  address: string,
): Promise<{ result: AccountDetailRes; error: errorType | null }> => {
  const url = `${constants.prefix}/${constants.versioning}/account/${address}`
  return Send.get<responseType<AccountDetailRes>>(`${config.EXPLORER_BACKEND_URL + url}`)
    .then((response) => {
      return {
        result: response.data.data,
        error: null,
      }
    })
    .catch((error: AxiosError) => {
      return {
        result: {} as AccountDetailRes,
        error: errorHandler(error),
      }
    })
}

export const getAccountDetail = async (address: string): Promise<responseType<AccountDetailRes>> => {
  const url = `${constants.prefix}/${constants.versioning}/account/${address}`
  return Send.get<responseType<AccountDetailRes>>(`${config.EXPLORER_BACKEND_URL + url}`).then(
    (response) => response.data,
  )
}
